<template>
  <qx-auto-complete v-model="supplierValue"
                    :disabled="disabled"
                    :fetch-suggestions="supplierSearch"
                    :orderDefaultValue="defaultValue"
                    @select="selectItem"
                    :value-key="itemName"
                    placeholder="请选择销售订单"/>
</template>

<script>
/**
 * @Description: 销售订单自动查询组件
 * @Author: 菩萨蛮
 * @Date: 2021/4/29 11:12 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */
import AutoComplete from '../../../mixins/common/AutoComplete';

export default {
  name: 'SaleOrderAutoComplete',
  mixins: [AutoComplete],
  data() {
    return {
      url: '/sales/sale_order?status=2&status=3&status=4&status=5&pageNum=0&pageSize=5&saleOrderNo=',
      itemName: 'saleOrderNo'
    };
  }
};
</script>

<style lang="scss" scoped>

</style>
